// extracted by mini-css-extract-plugin
export default {"value_text":"ValueText_value_text__Dogcs","value_text_little":"ValueText_value_text_little__ggM06","wrapper":"ValueText_wrapper__OQJ7I"};